import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcNearmeFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.74 4.022a.975.975 0 0 1 1.257 1.257l-6.059 16.047c-.308.816-1.45.848-1.803.052l-2.06-6.938a.98.98 0 0 0-.495-.495l-6.938-2.06c-.797-.354-.764-1.496.051-1.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.485 13.92 1.606 5.406 5.093-13.49-13.49 5.093 5.406 1.605.088.04c.56.249 1.009.697 1.258 1.257zm-8.843-2.036c-.797-.353-.764-1.495.051-1.803l16.048-6.059a.975.975 0 0 1 1.256 1.257l-6.059 16.047c-.308.816-1.45.848-1.803.052l-2.06-6.938a.98.98 0 0 0-.495-.495z",
    clipRule: "evenodd"
  }));
}
var IcNearmeFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNearmeFill));

export { IcNearmeFill as I };
